<template>
    <el-menu-item v-if="!(menu.children && menu.children.length)" :index="menu.code" class="flex-y-center">
        <i :class="menu.icon" />{{ menu.name }}
    </el-menu-item>
    <el-submenu v-else-if="menu.children && menu.children.length" :index="menu.code">
        <template slot="title">
            {{ menu.name }}
        </template>
        <submenu v-for="(item, index) in menu.children" :key="index" :menu="item" />
    </el-submenu>
</template>

<script>
export default {
    name: 'Submenu',
    props: ['menu'],
    data() {
        return {};
    }
};
</script>
